import * as React from 'react';

function FaQuote(props) {
  // Simple quote icon (SVG)
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width={props.size || 16} height={props.size || 16} {...props}>
      <path d="M7.5 6.5C7.5 4.57 9.07 3 11 3c1.93 0 3.5 1.57 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5-.28 0-.5.22-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 010 1h-2A1.5 1.5 0 019 12.5v-2c0-.83.67-1.5 1.5-1.5C12.88 9 14 7.88 14 6.5S12.88 4 11.5 4 9 5.12 9 6.5a.5.5 0 01-1 0zm-6 0C1.5 4.57 3.07 3 5 3c1.93 0 3.5 1.57 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5-.28 0-.5.22-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 010 1h-2A1.5 1.5 0 013 12.5v-2c0-.83.67-1.5 1.5-1.5C6.88 9 8 7.88 8 6.5S6.88 4 5.5 4 3 5.12 3 6.5a.5.5 0 01-1 0z" />
    </svg>
  );
}

export default FaQuote;
